module.exports = __webpack_public_path__ + "static/media/3 7 tattoo chest portrait woman realism memorial detailed.1280x1707.cc221ace.webp";